// Pure month arithmetic on YYYY-MM strings. No clock, no Date: parsing and
// adding whole months is plain integer maths, so it stays deterministic and
// safe to use inside the engine.
/** Split a YYYY-MM string into its year and 1-based month, validating shape. */
function parseMonth(month) {
    const match = /^(\d{4})-(\d{2})$/.exec(month);
    if (!match) {
        throw new RangeError(`Month must be YYYY-MM, received ${month}`);
    }
    const year = Number(match[1]);
    const monthNumber = Number(match[2]);
    if (monthNumber < 1 || monthNumber > 12) {
        throw new RangeError(`Month out of range, received ${month}`);
    }
    return { year, month: monthNumber };
}
/** Add a whole number of months (which may be negative) to a YYYY-MM string. */
export function addMonths(month, count) {
    if (!Number.isInteger(count)) {
        throw new RangeError(`Month offset must be an integer, received ${count}`);
    }
    const { year, month: monthNumber } = parseMonth(month);
    const zeroBased = year * 12 + (monthNumber - 1) + count;
    const newYear = Math.floor(zeroBased / 12);
    const newMonth = ((zeroBased % 12) + 12) % 12; // 0..11, correct for negatives
    return `${newYear}-${String(newMonth + 1).padStart(2, "0")}`;
}
//# sourceMappingURL=months.js.map